/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GuidanceToThePatientAliases {
  CHECK_AS_READ_ACTION = 'check-as-read-action',
  CONTEXTUAL_BAR = 'contextual-bar',
  GUIDANCE_TEXT = 'guidance-text',
  GUIDANCE_TO_THE_PATIENT_LAYOUT = 'guidance-to-the-patient-layout',
  LAYOUT_CONTEXTUALBAR_CONTENT = 'layout-contextualbar-content',
  PANEL = 'panel',
  PANEL_GUIDANCE_TEXT_GUIDANCE_TO_THE_PATIENT = 'panel-guidance-text-guidance-to-the-patient',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { GuidanceToThePatientAliases };
